import { axiosWithoutAuth, axiosAuth } from './axiosInstances'
//agregar una funcion por cada endpoint necesario, asegurarse de usar el async-await, ya que son peticiones a la api
// KHAN-123: moment esta en modo mantenimiento; dayjs cubre `.format()` con
// el mismo formato ISO-8601 con offset por defecto.
const dayjs = require('dayjs')

// KHAN-225: las acciones de autenticacion viven en auth/ (antes users/login/,
// users/tokenVerify/, users/password-reset/request|confirm/) y el recurso
// users sigue REST puro: users/ (lista/registro) y users/{id}/ (detalle/edicion).
export async function login(email, password) {
  return await axiosWithoutAuth().post('auth/login/', {
    email: email,
    password: password,
  })
}

export async function userListById(user_id) {
  return axiosAuth().get(`users/${user_id}/`)
}


export async function tokenVerify() {
  return await axiosAuth().post('auth/token/verify/')
}

export async function new_user(name, lastname, email, password) {
  return axiosWithoutAuth().post('users/', {
    email: email,
    name: name,
    lastname: lastname,
    password: password,
    createdat: dayjs().format(),
    actived: 1,
    username: null,
  })
}

export async function usersList() {
  return axiosAuth().get('users/')
}

// KHAN-225: PATCH users/{id}/ (antes PUT users/change/ con el email como llave).
export async function updateUser(userId,name,lastname,username) {
  return axiosAuth().patch(`users/${userId}/`,{
    name:name,
    lastname:lastname,
    username:username
  })
}

// KHAN-86: recuperación de contraseña.
export async function requestPasswordReset(email) {
  return axiosWithoutAuth().post('auth/password-reset/', {
    email: email,
  })
}

export async function confirmPasswordReset(token, newPassword) {
  return axiosWithoutAuth().post('auth/password-reset/confirm/', {
    token: token,
    new_password: newPassword,
  })
}

